import type { ImageSet } from "@b2bportal/core-themes";

export const images: ImageSet = {};

export default images;
